import "../../Css/Home/AppDownload.css";
import "react-international-phone/style.css";
import { HiMiniBuildingStorefront } from "react-icons/hi2";

import weddingvendor from "../../Images/weddingvendor.png";
import { Button } from "antd";
import { NavLink } from "react-router-dom";

const AppDownload = () => {
  return (
    <>
      <section className="home-page-app-download-con">
        <div className="container">
          <div className="home-page-app-download-main-con">
            <div className="row">
              <div className="col-12">
                <div className="home-page-app-download-main-div">
                  <div className="home-page-app-main-details-con">
                    <h3>Are You a Wedding Vendor? This Is Your Spot!</h3>
                    <p>
                      List your services, connect with clients, and grow your
                      business with Weddingz.adda.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-7">
                <img
                  className="w-100 h-100"
                  style={{
                    maxWidth: 500,
                    objectFit: "cover",
                    margin: "10px 0",
                  }}
                  src={weddingvendor}
                />
              </div>
              <div className="col-md-5 d-flex align-items-start justify-content-center  flex-column">
                <h4 style={{ textAlign: "start", color: "#fff" }}>
                  We Help to grow your business in Wedding industry
                </h4>
                <p style={{ textAlign: "start", color: "#dfdfdf" }}>
                  At Weddingz.adda, we offer a dedicated space for wedding
                  vendors like you to showcase your services, connect with
                  potential clients, and expand your reach in the ever-growing
                  wedding industry. Whether you're a venue owner, photographer,
                  makeup artist, or planner, our platform is built to put your
                  business in front of thousands of couples actively searching
                  for trusted vendors.
                </p>

                <NavLink to="/are-you-vendor">
                  <Button
                    className="business_list_button"
                    style={{ borderRadius: 0, height: 45 }}
                    icon={<HiMiniBuildingStorefront />}
                  >
                    List your Business !
                  </Button>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AppDownload;
